export default __webpack_public_path__ + "static/media/consorcioLogo.664f14e9.svg";